export default __webpack_public_path__ + "static/media/friendship-nft-720p.325b911b.mp4";